import React from 'react';
import { CheckCircleIcon } from 'lucide-react';
export function WhyChooseUs() {
  return <section className="w-full" style={{
    backgroundColor: '#1B2A4A'
  }} id="about" aria-label="Why choose us" data-id="element-172">
      <div className="max-w-7xl mx-auto" data-id="element-173">
        <div className="flex flex-col lg:flex-row" data-id="element-174">
          {/* Left: Image */}
          <div className="w-full lg:w-1/2 min-h-[400px] lg:min-h-[600px] overflow-hidden" data-id="element-175">
            <img src="https://images.unsplash.com/photo-1521737604893-d14cc237f11d?auto=format&fit=crop&w=900&q=80" alt="Professional team at work" className="w-full h-full object-cover" style={{
            minHeight: '400px'
          }} data-id="element-176" />
          </div>

          {/* Right: Content */}
          <div className="w-full lg:w-1/2 flex flex-col justify-center px-8 py-16 lg:px-16 lg:py-20" data-id="element-177">
            {/* Eyebrow */}
            <p className="text-xs font-semibold uppercase tracking-widest" style={{
            color: '#C8962E'
          }} data-id="element-178">
              WHY PRECISE TRANSCRIPTS
            </p>

            {/* Headline */}
            <h2 className="font-bold text-3xl text-white mt-3 mb-10 leading-snug" data-id="element-179">
              Accuracy, Security &amp; Speed — Every Time
            </h2>

            {/* Features */}
            <div className="flex flex-col gap-7" data-id="element-180">
              <div className="flex gap-4" data-id="element-181">
                <CheckCircleIcon className="w-5 h-5 mt-0.5 flex-shrink-0" style={{
                color: '#2DA5A0'
              }} aria-hidden="true" data-id="element-182" />
                <div data-id="element-183">
                  <p className="font-bold text-base text-white" data-id="element-184">
                    Pinpoint Accuracy
                  </p>
                  <p className="text-sm mt-1 leading-relaxed" style={{
                  color: '#C8C8C8'
                }} data-id="element-185">
                    Every transcript and translation is fully edited and
                    proofread. Each team member brings 7+ years of
                    industry-specific experience.
                  </p>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-186">
                <CheckCircleIcon className="w-5 h-5 mt-0.5 flex-shrink-0" style={{
                color: '#2DA5A0'
              }} aria-hidden="true" data-id="element-187" />
                <div data-id="element-188">
                  <p className="font-bold text-base text-white" data-id="element-189">
                    Military-Grade Security
                  </p>
                  <p className="text-sm mt-1 leading-relaxed" style={{
                  color: '#C8C8C8'
                }} data-id="element-190">
                    RAID storage, secure off-site backups, uninterruptible power
                    supply, and 99.9% uptime — your files are protected
                    24/7/365.
                  </p>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-191">
                <CheckCircleIcon className="w-5 h-5 mt-0.5 flex-shrink-0" style={{
                color: '#2DA5A0'
              }} aria-hidden="true" data-id="element-192" />
                <div data-id="element-193">
                  <p className="font-bold text-base text-white" data-id="element-194">
                    Fastest Turnaround
                  </p>
                  <p className="text-sm mt-1 leading-relaxed" style={{
                  color: '#C8C8C8'
                }} data-id="element-195">
                    Rush and standard options available. We guarantee the
                    fastest results in the industry without sacrificing quality.
                  </p>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-196">
                <CheckCircleIcon className="w-5 h-5 mt-0.5 flex-shrink-0" style={{
                color: '#2DA5A0'
              }} aria-hidden="true" data-id="element-197" />
                <div data-id="element-198">
                  <p className="font-bold text-base text-white" data-id="element-199">
                    HIPAA Compliant
                  </p>
                  <p className="text-sm mt-1 leading-relaxed" style={{
                  color: '#C8C8C8'
                }} data-id="element-200">
                    Fully compliant file submission and handling for medical,
                    legal, and sensitive documents.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}